export const PHASE_PRE_MATCH = 1;
export const PHASE_PRE_GAME = 2;
export const PHASE_PRE_POINT = 3;
export const PHASE_BETSTOP = 4;
export const PHASE_RALLY = 5;
export const PHASE_POST_POINT = 6;
export const PHASE_POST_GAME = 7;
export const PHASE_POST_MATCH = 8;

export const PHASE_NAMES : { [key:number]: string } = {
    1: 'PHASE_PRE_MATCH',
    2: 'PHASE_PRE_GAME',
    3: 'PHASE_PRE_POINT',
    4: 'PHASE_BETSTOP',
    5: 'PHASE_RALLY',
    6: 'PHASE_POST_POINT',
    7: 'PHASE_POST_GAME',
    8: 'PHASE_POST_MATCH',
}